dataWithOptimisticResults